<div *ngIf="loading!=true" class="container">

  <h1 style="align-self: center;">{{'Setup Induction Questions' | translate | async}}</h1>


  <div class="selection" style="width: 400px;align-self: center;flex-direction: row;align-items: center;justify-content:center;">
    
    <span>{{'Induction Type' | translate | async}} :</span>

      <mat-select style="width: 400px;" placeholder="{{'Induction Type' | translate | async}}" (selectionChange)="changeInductionCategory($event.value)"
        [(ngModel)]="selectedCategory">
        <mat-option *ngFor="let category of SetupInductionQuestion?.InductionTypes" [value]="category.ID">
          {{category?.Title}}
        </mat-option>
      </mat-select>
    
  </div>

  <div class="listConatiner">
    <mat-list role="list" *ngFor="let section of SetupInductionQuestion?.Selections">
      <mat-list-item role="listitem" style="display: flex;
      flex-direction: column;
      margin-bottom: 20px;margin-top: 20px;">

        <div class="CatTitle">
          <span>
            {{section.Title}}
          </span>
        </div>


      </mat-list-item>

      <!-- <div class="questionTitleContainer">
        <span class="QusTitle" style="display: flex;flex:0.5;align-items: center;justify-content: center;"> </span>
        <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">Question</span>
        <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">Type</span>
        <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">Slide</span>
        <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">Ans</span>
      </div> -->

      <table class="table table--striped table--full-width">
        <thead>
          <tr>
            <th><span class="QusTitle" style="display: flex;flex:0.5;align-items: center;justify-content: center;"> </span></th>
            <th>  <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">{{'Question' | translate | async}}</span></th>
            <th>  <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">{{'Type' | translate | async}}</span></th>
            <th>  <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">{{'Slide' | translate | async}}</span></th>
            <th>  <span class="QusTitle" style="display: flex;flex:1;align-items: center;justify-content: center;">{{"Ans" | translate | async}}</span></th>
            <th></th>
          </tr>
        </thead>
     <tbody>
      <ng-container *ngFor="let ques of section?.Questions">
        <tr>
          <td>
            <div style="display: flex;flex:0.5;align-items: center;justify-content: center;">

              <i (click)="clickQuestionenableDisable(ques)" class="material-icons button__icon"
                *ngIf="ques.Active == false" style="color: red;cursor: pointer;">close</i>
              <i (click)="clickQuestionenableDisable(ques)" class="material-icons button__icon"
                *ngIf="ques.Active == true" style="color: green;cursor: pointer;">done</i>

            </div>

          </td>
          <td>
            <div style="display: flex;flex:1;align-items: center;
            justify-content: left;">
              <span class="SectionTitle">{{ques.Question}}</span>
            </div>
          </td>
          <td>
            <div style="display: flex;flex:1;align-items: center;justify-content: center;">
              <span class="SectionTitle">{{ques.QuestionTypeName}}</span>
            </div>
          </td>
          <td>
            <div style="display: flex;flex:1;align-items: center;justify-content: center;">
              <span class="SectionTitle">{{ques.QuestionSlideName}}</span>
            </div>
          </td>
          <td>
            <div style="display: flex;flex:1;align-items: center;justify-content: center;">
              <span style="display: flex;flex-direction: row;" >

                <i style="cursor: pointer;" (click)="onClickEditQuestion(ques)"
                  class="material-icons button__icon">edit</i>

                <i style="margin-left: 20px;cursor: pointer;"  (click)="onClickSetupQuestionAnswer(ques)"
                  class="material-icons button__icon">comment</i>

                 

              </span>


            </div>
          </td>
          <td *ngIf="!ques.hasAnswers">
            <i style="margin-left: 20px;color:rgb(255, 0, 0)"  
            class="material-icons button__icon">warning</i>
          </td>
        </tr>
        
      </ng-container>
     </tbody>
     
      </table>

      <div class="addQuestionButton">
        <a class="button button--primary" (click)="openAddQuestionDialog(section)" color="lightgray">
          <i class="material-icons button__icon">add</i>
          <span class="button__text">{{'Add Question' | translate | async}}</span>

        </a>
      </div>


      <mat-divider></mat-divider>
    </mat-list>
  </div>
</div>

<div *ngIf="loading ==true"
  style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 800px;align-self: center;">
  <mat-spinner></mat-spinner>
</div>